const API = {
  success: 'success',
  fail: 'failed',
}

export default API;
